<template>
  <b-row>
    <b-col md="7">
      <iq-card>
        <template #headerTitle>
          <h4 class="card-title text-primary">
            <strong>
              Last Maintenance - {{ selectedData?.equipment_name }}
            </strong>
          </h4>
        </template>
        <template #body>
          <div class="row no-gutters px-2">
            <div class="col-md-12 pr-md-3 mb-3">
              <PmsFleetDetailHeader :selectedData="selectedData" />
            </div>
            <div class="col-md-12 mb-3">
              <CustomNav
                :items="leftTabs"
                @item-click="(tab) => (activeTabLeft = tab)"
              ></CustomNav>
            </div>
            <div class="col-md-12" v-if="activeTabLeft == 1">
              <table class="table table-striped mb-0">
                <tbody>
                  <tr>
                    <td class="text-muted" style="width: 30%">Status</td>
                    <td>
                      <span
                        class="badge"
                        :class="getStatusBadgeClass(selectedData?.status)"
                      >
                        {{ selectedData?.status }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-muted">Due</td>
                    <td class="font-semibold text-black">
                      <template v-if="selectedData.triggers == 'CALENDAR'">
                        {{ formatDate(selectedData.possible_maintenance_date) }}
                      </template>
                      <template v-else>
                        {{
                          formatNumber(
                            selectedData.possible_maintenance_hours
                          ) || '0'
                        }}
                        Hours
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-muted">Last Maintenance Date</td>
                    <td class="font-semibold text-black">
                      {{ formatDate(selectedData?.last_maintenance_date) }}
                    </td>
                  </tr>
                  <!-- <tr>
                    <td class="text-muted">Last Maintenance</td>
                    <td class="font-semibold text-black">
                      {{ formatDate(selectedData?.last_maintenance_date) }}
                    </td>
                  </tr> -->
                  <tr v-if="selectedData?.possible_maintenance_hours">
                    <td class="text-muted">Plan Maintenance (RH)</td>
                    <td class="font-semibold text-black">
                      {{
                        formatHours(selectedData?.possible_maintenance_hours)
                      }}
                      Hours
                    </td>
                  </tr>
                  <tr v-if="selectedData?.maintenance_running_hours">
                    <td class="text-muted">Actual Maintenance (RH)</td>
                    <td class="font-semibold text-black">
                      {{ formatHours(selectedData?.maintenance_running_hours) }}
                      Hours
                    </td>
                  </tr>
                  <tr>
                    <td class="text-muted">Cost</td>
                    <td class="font-semibold text-black">
                      {{ formatCurrency(selectedData?.cost) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-muted">Attachment</td>
                    <td>
                      <b-badge
                        v-for="(file, idx) in selectedData?.attachments"
                        :key="`att-${idx}`"
                        variant="warning"
                        pill
                        class="mr-2 cursor-pointer"
                        @click="onPreview(file?.fileurl)"
                      >
                        {{ file?.filename }}
                        <i
                          class="fa fa-download ml-2"
                          style="font-size: 12px"
                        ></i>
                      </b-badge>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-muted">Notes</td>
                    <td class="font-semibold text-black">
                      {{ selectedData?.notes ?? '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <TablePostponed :selectedData="selectedData" />
            </div>
            <div class="col-md-12" v-if="activeTabLeft == 2">
              <table class="table table-striped mb-0">
                <tbody>
                  <tr>
                    <td class="text-muted" style="width: 20%">Job Code</td>
                    <td class="font-semibold text-black" style="width: 30%">
                      {{ selectedData?.job_library?.code }}
                    </td>
                    <td class="text-muted" style="width: 20%">Job Name</td>
                    <td class="font-semibold text-black" style="width: 30%">
                      {{ selectedData?.job_library?.name }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-muted">Equipment Category</td>
                    <td class="font-semibold text-black text-uppercase">
                      {{
                        selectedData?.job_library?.maintenance_component
                          ?.component_name
                      }}
                    </td>
                    <td class="text-muted">Equipment</td>
                    <td class="font-semibold text-black">
                      {{
                        selectedData?.job_library?.maintenance_master
                          ?.equipment_name
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-muted">Job Type</td>
                    <td class="font-semibold text-black">
                      {{
                        selectedData?.job_library?.maintenance_job_type
                          ?.job_type_index
                      }}
                    </td>
                    <td class="text-muted">Method</td>
                    <td class="font-semibold text-black">
                      {{ selectedData?.job_library?.method }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-muted">Interval</td>
                    <td class="font-semibold text-black" colspan="3">
                      <template v-if="selectedData.triggers == 'COUNTER'">
                        {{ selectedData?.trigger_interval ?? '0' }} Hours
                      </template>
                      <template v-else>
                        {{ selectedData?.trigger_interval }}
                        {{ selectedData?.trigger_calendar_type }}
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-muted align-top">Job Description</td>
                    <td
                      colspan="3"
                      class="font-semibold text-black job-description"
                      v-html="selectedData?.job_library?.job_description || '-'"
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-12" v-if="activeTabLeft == 3">
              <MaintenanceRhList
                :maintenanceDetailData="{
                  vehicle: { id: selectedData?.vehicle_id },
                }"
              />
            </div>
          </div>
        </template>
      </iq-card>
    </b-col>
    <b-col md="5">
      <iq-card>
        <template #headerTitle>
          <h4 class="card-title text-primary">
            <strong>
              Process Maintenance - {{ selectedData?.equipment_name }}
            </strong>
          </h4>
        </template>
        <template #body>
          <div class="mb-3 text-primary">
            <strong>
              {{ selectedData?.power_type_name }} - {{ selectedData?.power_series_name }}  {{ selectedData?.power_series_model }}
            </strong>
          </div>
          <CustomNav
            :items="rightTabs"
            @item-click="(tab) => (activeTabRight = tab)"
            class="mb-3"
          ></CustomNav>
          <div v-show="activeTabRight == 1">
            <FormMaintenanceProcessSingle
              :methodType="selectedData?.triggers"
              :selectedData="selectedData"
              :isEditMode="isEditMode"
              @refetch="$emit('refetch')"
              @close="$emit('close')"
            />
          </div>
          <div v-show="activeTabRight == 2">
            <MaintenanceCommentFormNew :selectedData="selectedData" />
          </div>
          <div v-show="activeTabRight == 3">
            <MaintenanceLogs
              :logs="
                selectedData?.logs.map((log) => ({
                  name: log?.user?.username || '-',
                  date: log.created_date,
                  description: `Changed Status to ${log.status}`,
                }))
              "
            />
          </div>
        </template>
      </iq-card>
    </b-col>
  </b-row>
</template>

<script>
import moment from '@/node_modules/moment/moment'
import CustomNav from '@/src/components/global/CustomNav.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import MaintenanceRhList from './Tabs/MaintenanceRhList.vue'
import FormMaintenanceProcessSingle from './FormMaintenanceProcessSingle.vue'
import MaintenanceCommentFormNew from './Tabs/MaintenanceCommentFormNew.vue'
import MaintenanceLogs from './Tabs/MaintenanceLogs.vue'
import PmsFleetDetailHeader from './PmsFleetDetailHeader.vue'
import TablePostponed from './TablePostponed.vue'
import { getMiStatusBadgeClass, previewFile } from '../../../plugins/helpers'

export default {
  name: 'MaintenanceProcessInfo',
  props: {
    selectedData: {
      type: Object,
      default: () => null,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CustomNav,
    MaintenanceRhList,
    FormMaintenanceProcessSingle,
    MaintenanceCommentFormNew,
    MaintenanceLogs,
    PmsFleetDetailHeader,
    TablePostponed,
  },
  data() {
    return {
      limitOptions,
      activeTabLeft: 1,
      activeTabRight: 1,
      leftTabs: [
        { label: 'Last Maintenance Info', value: 1 },
        { label: 'Job Library', value: 2 },
        { label: 'Running Hours Info', value: 3 },
      ],
      rightTabs: [
        { label: 'Maintenance', value: 1 },
        { label: 'Comment', value: 2 },
        { label: 'Logs', value: 3 },
      ],
    }
  },
  methods: {
    onPreview(fileUrl) {
      previewFile(fileUrl)
    },
    getStatusBadgeClass() {
      return getMiStatusBadgeClass(this.selectedData?.status)
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      return moment(dateStr).format('DD MMMM YYYY')
    },
    formatCurrency(val) {
      if (val === null || val === undefined) return '-'
      const formatted = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(val)
      // Gaya seperti "Rp. 15.500.350,-"
      return formatted.replace('Rp', 'Rp.') + ',-'
    },
    formatHours(val) {
      if (val === null || val === undefined) return '-'
      return new Intl.NumberFormat('id-ID').format(val)
    },
    formatNumber(number) {
      // Format number with thousand separators
      if (!number && number !== 0) return '-'

      return Number(number).toLocaleString('id-ID')
    },
    formatInterval(job) {
      if (!job) return '-'
      if (job.method === 'CALENDAR') {
        const interval = Number(job.calendar_interval) || 0
        const unit = (job.calendar_type || '').toLowerCase()
        if (!interval || !unit) return '-'
        const label = unit.charAt(0).toUpperCase() + unit.slice(1)
        return `${interval} ${label}${interval > 1 ? 's' : ''}`
      }
      return '-'
    },
  },
}
</script>

<style scoped>
.fleet-image {
  width: 100%;
  height: 240px;
  background: #e9edf4 center/cover no-repeat;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.icon-badge {
  width: 60px;
  height: 60px;
  background: #f4efe6;
  border-radius: 6px;
  display: inline-block;
}
thead.thead-light th {
  background: #f8f9fa;
}
.font-semibold {
  font-weight: 500;
}

:deep(.job-description ul) {
  list-style-type: disc !important;
  padding-left: 20px !important;
  margin-bottom: 10px !important;
}

:deep(.job-description li) {
  list-style-type: disc !important;
  margin-bottom: 5px !important;
  display: list-item !important;
}

:deep(.job-description ol) {
  list-style-type: decimal !important;
  padding-left: 20px !important;
  margin-bottom: 10px !important;
}

:deep(.job-description ol li) {
  list-style-type: decimal !important;
}
</style>
